const key = `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=pGTN
-----END PGP PUBLIC KEY BLOCK-----`;

export default key;
